var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.375 9.74957H11.875M2.375 11.7496H9.375M2.375 13.7496H10.875M2.375 15.7496H11.5352M2.375 18.7496H7.875M2.375 20.7496H4.375M6.375 20.7496H8.875M13.4926 14H17.1238C17.8009 14 18.2823 13.3411 18.0764 12.696L17.5352 11H18.9171C19.6605 11 20.144 10.2177 19.8115 9.55279L19.0352 8H20.1203C20.8006 8 21.2823 7.33534 21.0706 6.68879L19.5352 2L15.2277 10.5299L12.2277 16.5299M12.2277 16.5299L11.2277 18.5299L10.7277 19.5152L12.2065 18.6149C12.6379 18.3522 12.8058 17.8091 12.5978 17.3489L12.2277 16.5299ZM0.5 7.49957H14.25V23.9996H0.5V7.49957Z",
    stroke: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIcon);
export default __webpack_public_path__ + "static/media/contact-icon.4fc92311ef4f3224466b308f7d9f0770.svg";
export { ForwardRef as ReactComponent };